/*
 * Copyright (c) Worldline 2023.
 */

import {Component, OnInit} from '@angular/core';
import {RedirectionService} from "../../services/redirection.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html'
})
export class ContactComponent implements OnInit {

  constructor(private redirectionService: RedirectionService, private route: ActivatedRoute) {
  }

  private sessionId: any

  ngOnInit(): void {
    this.sessionId = this.route.snapshot.params['sessionId'];
  }

  back() {
    this.redirectionService.session(this.route, this.sessionId);
  };

}
